import template1 from './1/component';
import template2 from './2/component';

const templates = {
	1: template1,
	2: template2,
};

export default templates;
export function MinicartGroup(templateId = 1) {
	return templates[templateId]();
}
